import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useParams, useLocation } from "react-router-dom";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { LoginPage } from "./components/LoginPage";
import { usePageTracking } from "./hooks/usePageTracking";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { ServicesSection } from "./components/ServicesSection";
import { NewFeaturesSection } from "./components/NewFeaturesSection";
import { AboutSection } from "./components/AboutSection";
import { CEOMessageSection } from "./components/CEOMessageSection";
import { TrustedBySection } from "./components/TrustedBySection";
import { StatsSection } from "./components/StatsSection";
import { VideoSection } from "./components/VideoSection";
import { TestimonialsSection } from "./components/TestimonialsSection";
import { ContactSection } from "./components/ContactSection";
import { Footer } from "./components/Footer";
import { ServiceDetailPage } from "./components/ServiceDetailPage";
import { ServicesPage } from "./components/ServicesPage";
import { AboutPage } from "./components/AboutPage";
import { ContactPage } from "./components/ContactPage";
import { SolutionsPage } from "./components/SolutionsPage";
import { CareerPage } from "./components/CareerPage";
import { ProjectsPage } from "./components/ProjectsPage";
import { ProjectDetailPage } from "./components/ProjectDetailPage";
import { PrivacyPolicy } from "./components/PrivacyPolicy";
import { CookiePolicy } from "./components/CookiePolicy";
import { TermsOfService } from "./components/TermsOfService";
import { CookieConsent } from "./components/CookieConsent";
import { AdminPanel } from "./components/AdminPanel";
import { mockData } from "./components/mock";

const LandingPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <StatsSection />
        <ServicesSection />
        <NewFeaturesSection />
        <AboutSection />
        <CEOMessageSection />
        <TrustedBySection />
        <VideoSection />
        <TestimonialsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

// Service Detail Route Component
const ServiceDetailRoute = () => {
  const { id } = useParams(); // Get service ID from URL parameters
  const service = mockData.services.find(s => s.id === parseInt(id));
  
  const handleBack = () => {
    window.history.back();
  };

  if (!service) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Service Not Found</h1>
          <p className="text-gray-600 mb-8">The requested service could not be found.</p>
          <button 
            onClick={() => window.location.href = '/'}
            className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700"
          >
            Back to Home
          </button>
        </div>
      </div>
    );
  }

  return <ServiceDetailPage service={service} onBack={handleBack} />;
};

// Scroll to top component
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// Page tracking wrapper component - tracks all visitors anonymously
const PageTracker = () => {
  usePageTracking();
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <PageTracker />
        <CookieConsent />
        <Routes>
          {/* Public Routes - No Authentication Required */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/career" element={<CareerPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/service/:id" element={<ServiceDetailRoute />} />
          <Route path="/projects/:projectId" element={<ProjectDetailPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          
          {/* Admin Login Page */}
          <Route path="/login" element={<LoginPage />} />
          
          {/* Admin Route - Protected with Password */}
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute>
                <AdminPanel />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
